import { FC } from 'react';
import styles from './agencyForm.module.scss';

/**
 * 當父層 add-on（channel / ad type）全部關閉、導致此分頁沒有可設定的項目時，
 * 顯示置中的提示文字。
 */
export const AddonSectionPlaceholder: FC<{ message: string }> = ({
  message
}) => <div className={styles.addonPlaceholder}>{message}</div>;
